import { Button } from '@/components/ui/Button';
import { CoachModal } from '@/features/coach/components/CoachModal';

/** Explicit destination choice only. This dialog owns no writing or persistence. */
export function FeedbackResourceDestination({ kept, onKept, onNew, onSaved, onClose }: {
  kept: readonly { id: string; label: string }[]; onKept(entryId: string): void;
  onNew(): void; onSaved(): void; onClose(): void;
}) {
  return <CoachModal title="Link Resource to Feedback" description="The Resource is already saved. Choose where to use this exact saved version." onClose={onClose}>
    {!!kept.length && <section aria-label="Kept Feedback writing" className="space-y-2">
      <h3 className="font-display font-semibold">Continue writing</h3>
      {kept.map(entry => <div key={entry.id} className="flex items-center justify-between gap-3 rounded-control border border-rule p-3 text-sm">
        <span>{entry.label}</span><Button size="sm" variant="outline" onClick={() => onKept(entry.id)}>Continue and link</Button>
      </div>)}
    </section>}
    <div className="mt-4 flex flex-wrap gap-2"><Button onClick={onNew}>New Feedback and link</Button><Button variant="outline" onClick={onSaved}>Choose draft</Button></div>
    <p className="mt-3 text-xs text-ink-muted">Linking changes your selected draft. Review and publication remain separate.</p>
  </CoachModal>;
}
